var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87013 6.11332L10.2667 3.2093V13.6652C10.2667 14.0714 10.5945 14.4 11 14.4C11.4055 14.4 11.7333 14.0714 11.7333 13.6652V3.18146L14.1526 6.11332C14.4393 6.40298 14.9057 6.40298 15.1939 6.11332C15.4807 5.82512 15.4807 5.3565 15.1939 5.06756L11.5691 0.674189C11.4151 0.520189 11.2119 0.454163 11.0117 0.465163C10.8108 0.454163 10.6077 0.520189 10.4544 0.674189L6.82952 5.06756C6.54206 5.3565 6.54206 5.82512 6.82952 6.11332C7.11699 6.40298 7.5834 6.40298 7.87013 6.11332ZM21.2667 12.2C20.8611 12.2 20.5333 12.5285 20.5333 12.9333V18.0666H1.46667V12.9333C1.46667 12.5285 1.13887 12.2 0.733333 12.2C0.3278 12.2 0 12.5285 0 12.9333V18.8C0 19.2055 0.3278 19.5333 0.733333 19.5333H21.2667C21.6722 19.5333 22 19.2055 22 18.8V12.9333C22 12.5285 21.6722 12.2 21.2667 12.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.87dea1a93e2bb1efe63a3b07dbeb48b3.svg";
export { ForwardRef as ReactComponent };